'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggle = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

require('slick-carousel');

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toggle = exports.toggle = function toggle(e, $accordion) {
  // e.stopImmediatePropagation();

  var attr = $accordion.next().attr('data-accordion-content');

  if ($accordion.hasClass(_Dom2.default.active)) {
    close($accordion);

    if ((typeof attr === 'undefined' ? 'undefined' : (0, _typeof3.default)(attr)) !== (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined)) && attr !== false) {
      $accordion.next().slideUp();
    }
  } else {

    open($accordion);

    if ((typeof attr === 'undefined' ? 'undefined' : (0, _typeof3.default)(attr)) !== (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined)) && attr !== false) {
      $accordion.next().slideDown();
    }
  }
};

var open = function open($accordion) {
  $accordion.addClass(_Dom2.default.active);
  if ($('.pdp-tabs .is-active [data-lifestyle-image]').not('.slick-initialized').length) {
    $('[data-lifestyle-image]').slick();
  }
};

var close = function close($accordion) {
  $accordion.removeClass(_Dom2.default.active);
};